module.exports = __webpack_public_path__ + "static/media/armor-upgrade.c51f9198.svg";